import { useMemo } from 'react'
import { RxValueNone } from 'react-icons/rx'
import { Else, If, Then } from 'react-if'
import { DataType } from '~/common/generated/apollo-operations'
import { useLookupContext } from '~/components/records/lookup/hooks/LookupProvider'
import { useTypedTranslation } from '../../../common/hooks/useTypedTranslation'
import { AllTablesQueryTableColumn, PreviewCell } from './types'

interface LookupColumnPreviewCellProps {
  cell: PreviewCell
  column: AllTablesQueryTableColumn
  showDisabledState: boolean
}
/**
 * Renders a single cell for a lookup column in the preview data section
 */
export function LookupColumnPreviewCell({
  cell,
  column,
  showDisabledState,
}: LookupColumnPreviewCellProps) {
  const { t } = useTypedTranslation()
  const { getCellDisplay } = useLookupContext()

  const cellDisplay = useMemo(() => {
    return getCellDisplay(cell, column.id)
  }, [cell, column.id, getCellDisplay])

  return (
    <div
      key={cell.id}
      className={`truncate border-b border-gray-4 p-2 ${showDisabledState && 'text-gray-8'}`}
    >
      {/** If lookup type cell and the cell that it is looking up is empty, show the empty state instead of empty string  */}
      <If
        condition={
          (column.type === DataType.LOOKUP || column.innerType === DataType.LOOKUP) && !cellDisplay
        }
      >
        <Then>
          <div className="flex items-center gap-1">
            <RxValueNone />
            {t('table_column.empty')}
          </div>
        </Then>
        <Else>{cellDisplay}</Else>
      </If>
    </div>
  )
}
